import { useEffect, useRef } from 'react';

import { useAuth0LoginRedirect } from './useAuth0LoginRedirect';

/**
 * Automatically starts Auth0 login when enabled.
 * Uses a ref so React Strict Mode double-mount does not trigger twice.
 */
export function useAutoAuth0Login(enabled: boolean) {
  const login = useAuth0LoginRedirect();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!enabled || startedRef.current) {
      return;
    }
    startedRef.current = true;
    void login();
  }, [enabled, login]);
}
